<template lang="pug">
v-expansion-panels
  v-expansion-panel
    v-expansion-panel-header
      div.text-h6 From {{ referral.referrerName}} for {{ referral.salesPerson }}
    v-expansion-panel-content
      v-card-text
        v-row
          v-col(cols=12, lg=6)
            v-card.my-2(outlined, height="100%")
              v-card-title
                h5 Referrer
              v-card-text
                v-row
                  v-col(cols=12, lg=6)
                    div.text-h5 Name
                  v-col(cols=12, lg=6, :class="{ blurred: blurReferrer }")
                    p {{ referral.referrerName || 'Dunno McDunno' }}
                v-row
                  v-col(cols=12, lg=6)
                    div.text-h6 Email
                  v-col(cols=12, lg=6, :class="{ blurred: blurReferrer }")
                    p {{ referral.referrerEmail || 'dunno@mcdunno.face' }}
                v-row
                  v-col(cols=12, lg=6)
                    div.text-h6 Message
                  v-col(cols=12, lg=6, :class="{ blurred: blurReferrer }")
                    p {{  referral.referralMessage || (blurReferrer ? "I don't know what to write about,\" said Paul, a former deputy governor of Florida. \"But he's got to put in more and more effort on the issues of education. That's why he's here. " : "")  }}
          v-col(cols=12, lg=6)
            v-card.my-2(v-if="updated", outlined, height="100%")
              v-card-title
                h5 Referred
              v-card-text
                v-row
                  v-col(cols=12, lg=6)
                    div.text-h5 Name
                  v-col(cols=12, lg=6, :class="{ blurred: blurReferrer }")
                    p {{ referral.referredName || 'Dunno McDunno' }}
                v-row
                  v-col(cols=12, lg=6)
                    div.text-h6 Email
                  v-col(cols=12, lg=6, :class="{ blurred: blurReferrer }")
                    p {{ referral.referredEmail || 'dunno@mcdunno.face' }}
                v-row
                  v-col(cols=12, lg=6)
                    hdiv.text-h6Phone
                  v-col(cols=12, lg=6, :class="{ blurred: blurReferrer }")
                    p {{ referral.referredPhone || 'dunno@mcdunno.face' }}
            v-card.my-4(v-if="!updated", outlined, height="100%")
              v-card-title Referred
              v-card-text
                v-row
                  v-col(cols=12, lg=6)
                    div.text-h5 Name
                  v-col(cols=12, lg=6, :class="{ blurred: !updated }")
                    p {{ referral.referredName || 'Dunno McDunno' }}
                v-row
                  v-col(cols=12, lg=6)
                    div.text-h6 Email
                  v-col(cols=12, lg=6, :class="{ blurred: !updated }")
                    p {{ referral.referredEmail || 'dunno@mcdunno.face' }}
                v-row
                  v-col(cols=12, lg=6)
                    div.text-h6 Phone
                  v-col(cols=12, lg=6, :class="{ blurred: !updated }")
                    p {{ referral.referredPhone || 'dunno@mcdunno.face' }}
      v-card-actions.py-4
        v-spacer
        v-btn.secondary(@click="emailReferrer" v-if="referral.referrerEmail") Contact {{ referral.referrerName }}
        v-btn.secondary(@click="emailReferred" v-if="referral.referredEmail") Contact {{ referral.referredName }}
        v-dialog(v-model="contactDialog", max-width="540" v-if="updated && awarded")
          template(v-slot:activator="{ on }")
            v-btn(v-on="on" class="mx-2") Award points
          v-card
            v-card-title.headline Points already awarded
            v-card-text
              p Contact Power Trip to award more points on 
                a(href="tel:+64226495517") 022 649 5517
        v-dialog(v-model="dialog", max-width="540" v-if="updated && !awarded")
            template(v-slot:activator="{ on }")
                v-btn(v-on="on" class="primary mx-2") Award points
            v-card
                v-card-title.headline Congratulations!
                v-card-text
                    p You've accepted a referral, choose how many Lightning Points you want to reward {{ referral.referrerName }} and {{ referral.referredName }} with:
                    v-text-field(v-if="!referral.referrerRewarded" v-model.number="referrerPoints" type="number" :label="referral.referrerName" :min="$dealer.default_settings.minpoints")
                    p(v-if="referral.referrerRewarded") {{ referral.referrerName }} has already received Lightning Points
                    v-text-field(v-if="!referral.referredRewarded" v-model.number="referredPoints" type="number" :label="referral.referredName" :min="$dealer.default_settings.minpoints")
                    p(v-if="referral.referredRewarded") {{ referral.referredName }} has already received Lightning Points
                v-card-actions.py-4
                    v-spacer
                    v-dialog(v-model="confirmDialog", max-width="540")
                      template(v-slot:activator="{ on }")
                        v-btn.primary(v-on="on" class="primary mx-2") Award Points
                      v-card
                        v-card-title.headline Confirm
                        v-card-text
                          p You are going to award the following Lightning Points:
                          p {{ referrerPoints }} to {{ referral.referrerName }}
                          p {{ referredPoints }} to {{ referral.referredName }}
                        v-card-actions.py-4
                          v-spacer
                          v-btn.primary(@click="awardPoints") Confirm
                          v-btn(@click="confirmDialog = false") Cancel
                    v-btn(@click="dialog = false") Cancel 
</template>

<script>
export default {
  props: ["referral"],
  data() {
      return {
          dialog: false,
          confirmDialog: false,
          contactDialog: false,
          referrerPoints: this.$dealer.default_settings.minpoints,
          referredPoints: this.$dealer.default_settings.minpoints,
          awarded: this.referral.referrerRewarded && this.referral.referredRewarded
      }
  },
  methods: {
    emailReferrer() {
      window.open("mailto:" + this.referral.referrerEmail, "_blank");
    },
    emailReferred() {
      window.open("mailto:" + this.referral.referredEmail, "_blank");
    },
    awardPoints() {
        this.$dealer.assignPoints(this.referral.referralCode,this.referrerPoints,this.referredPoints).then(response=>{
            console.log(response);
            this.dialog = false;
            this.awarded = true;
        });
    }
  },
  computed: {
    blurReferrer() {
      return !this.referral.referrerName;
    },
    updated() {
      return this.referral.referredName || this.referral.referredEmail;
    },
  },
};
</script>
<style scoped>
.blurred {
  filter: blur(4px);
}
.right {
  float: right;
}
</style>